import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function scrollToTop() {
  window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  document.documentElement.scrollTo?.({ top: 0, left: 0, behavior: "smooth" });
  document.body.scrollTo?.({ top: 0, left: 0, behavior: "smooth" });
  const dashboardMain = document.querySelector(".dashboard-main");
  if (dashboardMain) dashboardMain.scrollTo({ top: 0, left: 0, behavior: "smooth" });
}

export default function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(scrollToTop);
    });
  }, [location.pathname, location.search]);

  return null;
}
